import { motion } from "framer-motion";
import { ChevronRight, Home } from "lucide-react";

const ACCENT = "#4FA3D9";

const line = {
  hidden: { opacity: 0, y: 18 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0.3 + i * 0.55 },
  }),
};

export const Ending = ({ onContinue, onHome }) => {
  return (
    <div className="relative flex h-[100dvh] w-full items-center justify-center overflow-hidden bg-[#0a0a0a] grain" data-testid="ending-screen">
      <button onClick={onHome} data-testid="home-btn" aria-label="Home" className="fixed left-5 top-6 z-50 flex h-10 w-10 items-center justify-center rounded-full border border-white/12 bg-black/30 text-white/75 backdrop-blur-xl transition-colors hover:bg-black/50 hover:text-white sm:left-7">
        <Home size={16} />
      </button>
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 h-[60vh] w-[60vh] -translate-x-1/2 -translate-y-1/2 rounded-full blur-[130px] animate-light-drift" style={{ background: "rgba(79,163,217,0.14)" }} />
      </div>

      <div className="relative z-10 mx-auto max-w-xl px-8 text-center">
        <motion.p variants={line} initial="hidden" animate="show" custom={0} className="mb-8 text-xs font-semibold uppercase tracking-[0.4em] text-white/50">
          Simulation Complete
        </motion.p>

        <motion.p variants={line} initial="hidden" animate="show" custom={1} className="font-display text-2xl font-medium leading-snug text-white sm:text-3xl">
          None of that actually happened.
        </motion.p>
        <motion.p variants={line} initial="hidden" animate="show" custom={2} className="mt-3 font-display text-2xl font-medium leading-snug text-white/85 sm:text-3xl">
          But the decisions you made were yours.
        </motion.p>
        <motion.p variants={line} initial="hidden" animate="show" custom={3} className="mt-3 text-lg text-white/55">
          That's why we practise.
        </motion.p>

        <motion.div variants={line} initial="hidden" animate="show" custom={4} className="mt-14">
          <div className="flex items-start justify-center">
            <img src="/adaptience-logo.png" alt="Adaptience" className="h-7 w-auto sm:h-8" />
            <sup className="ml-0.5 mt-0.5 text-[9px] text-white/50">™</sup>
          </div>
          <p className="mt-3 text-sm italic text-white/45">
            Don't wait for life to test you. Practice before it does.
          </p>
        </motion.div>

        <motion.button
          variants={line}
          initial="hidden"
          animate="show"
          custom={5}
          onClick={onContinue}
          data-testid="ending-continue-btn"
          className="group mt-14 inline-flex max-w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border px-6 py-4 text-xs font-semibold uppercase tracking-[0.1em] transition-[color,background-color] duration-500 active:scale-[0.98] sm:gap-3 sm:px-8 sm:text-sm sm:tracking-[0.18em]"
          style={{ borderColor: ACCENT, color: ACCENT }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = ACCENT; e.currentTarget.style.color = "#fff"; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.color = ACCENT; }}
        >
          See how you handled it
          <ChevronRight size={16} className="shrink-0 transition-transform duration-500 group-hover:translate-x-1" />
        </motion.button>
      </div>
    </div>
  );
};

export default Ending;
